import { produce } from "immer";
import { Store } from "reducers/rootReducer";

/* STATE */

type State = {
  closeParentMenu: boolean;
};

const initialState: State = {
  closeParentMenu: false,
};

/* ACTIONS */

const CLOSE_PARENT_MENU = "app/parentMenu/CLOSE_PARENT_MENU";
const RESET_CLOSE_PARENT_MENU = "app/parentMenu/CLOSE_PARENT_MENU";

type Action =
  | {
      type: typeof CLOSE_PARENT_MENU;
      payload: boolean;
    }
  | { type: typeof RESET_CLOSE_PARENT_MENU; payload: boolean };

/* REDUCER */

export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case CLOSE_PARENT_MENU:
        draft.closeParentMenu = action.payload;
        break;
      case RESET_CLOSE_PARENT_MENU:
        draft.closeParentMenu = action.payload;
        break;
    }
  });
}

export const setCloseParentMenu = (): Action => ({
  type: CLOSE_PARENT_MENU,
  payload: true,
});

export const setResetCloseParentMenu = (): Action => ({
  type: RESET_CLOSE_PARENT_MENU,
  payload: false,
});

/* SELECTORS */

export const selectCloseParentMenu = (app: Store) =>
  app.parentMenu.closeParentMenu;
